export default __webpack_public_path__ + "static/media/007-pancakes.df972387.svg";